
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/book/roulette",
      function () {
        return require("private-next-pages/book/roulette/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/book/roulette"])
      });
    }
  